import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  // ================= DESKTOP DROPDOWNS =================
  const [infoOpenDesktop, setInfoOpenDesktop] = useState(false);
  const [movingOpenDesktop, setMovingOpenDesktop] = useState(false);
  const [cranesOpenDesktop, setCranesOpenDesktop] = useState(false);

  // ================= MOBILE DROPDOWNS =================
  const [infoOpenMobile, setInfoOpenMobile] = useState(false);
  const [movingOpenMobile, setMovingOpenMobile] = useState(false);
  const [cranesOpenMobile, setCranesOpenMobile] = useState(false);

  // ================= BODY SCROLL =================
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  // ================= CLOSE MOBILE MENU =================
  const closeMobileMenu = () => {
    setMenuOpen(false);
    setInfoOpenMobile(false);
    setMovingOpenMobile(false);
    setCranesOpenMobile(false);
  };

  return (
    <>
      {/* =========================================================
          HEADER
      ========================================================= */}
      <header className={`header ${menuOpen ? "menu-open" : ""}`}>

        {/* ================= LOGO ================= */}
        <div className="logo">
          <img src="/logo.png" alt="נצר הובלות ומנופים" />
        </div>

        {/* ================= DESKTOP NAV ================= */}
        <nav className="nav desktop-nav">

          <Link to="/">בית</Link>


          {/* =====================================================
              הובלת מבנים
          ===================================================== */}
          <div
            className="dropdown"
            onMouseEnter={() => setInfoOpenDesktop(true)}
            onMouseLeave={() => setInfoOpenDesktop(false)}
          >

            <Link
              to="/Building_Transportation/"
              className="drop-title"
            >
              הובלת מבנים ▾
            </Link>

            {infoOpenDesktop && (
              <div className="dropdown-menu">

                <Link to="/Relocation_of_buildings/">
                  העברת מבנים
                </Link>

                <Link to="/Lifting_Buildings/">
                  הרמת מבנים
                </Link>

                <Link to="/BuildingRehabilitation/">
                  הובלת קרוואנים
                </Link>

                <Link to="/Transportation_of_protective_equipment_and_mobile_safe_room/">
                  הובלת מיגונית וממ”ד נייד
                </Link>

              </div>
            )}

          </div>


          {/* =====================================================
              הובלות עם מנוף הרמה
          ===================================================== */}
          <div
            className="dropdown"
            onMouseEnter={() => setMovingOpenDesktop(true)}
            onMouseLeave={() => setMovingOpenDesktop(false)}
          >

            <Link
              to="/Moving_with_a_lifting_crane/"
              className="drop-title"
            >
              הובלות עם מנוף הרמה ▾
            </Link>

            {movingOpenDesktop && (
              <div className="dropdown-menu">

                <Link to="/Transportation_of_building_materials">
                  הובלת חומרי בניין
                </Link>

                <Link to="/Transporting_wood">
                  הובלת עצים
                </Link>

                <Link to="/Transporting_heavy_equipment">
                  הובלת ציוד כבד
                </Link>

                <Link to="/Container_Transportation">
                  הובלת מכולות
                </Link>

                <Link to="/Transportation_and_lifting_of_glass_in_a_vacuum">
                  הובלה והרמה של זכוכית בוואקום
                </Link>

                <Link to="/Transportation_of_industrial_and_heavy_generators">
                  הובלת גנרטורים תעשייתיים וכבדים
                </Link>

              </div>
            )}

          </div>


          {/* =====================================================
              השכרת מנופים
          ===================================================== */}
          <div
            className="dropdown"
            onMouseEnter={() => setCranesOpenDesktop(true)}
            onMouseLeave={() => setCranesOpenDesktop(false)}
          >

            <Link
              to="/Crane_Rental/"
              className="drop-title"
            >
              השכרת מנופים ▾
            </Link>

            {cranesOpenDesktop && (
              <div className="dropdown-menu">

                <Link to="/Basket_crane_rental/">
                  השכרת מנוף סל
                </Link>

                <Link to="/Crane_Rental1/">
                  השכרת מנוף זרוע
                </Link>

                <Link to="/Hourly_Lifting_Basket_Rental/">
                  השכרת סל הרמה לפי שעה
                </Link>

                <Link to="/Renting_a_basket_crane_for_lifting_a_person/">
                  השכרת מנוף סל להרמת אדם
                </Link>

              </div>
            )}

          </div>


          {/* עבודות מנוף בפריסה ארצית */}
          <Link to="/Crane_work_nationwide">
            עבודות מנוף בפריסה ארצית
          </Link>

          {/* גלריה */}
          <Link to="/WorksGallery">
            גלריית עבודות
          </Link>

          {/* אודות */}
          <Link to="/About">
            אודות
          </Link>

          {/* צור קשר */}
          <Link to="/ContactSection2">
            צור קשר
          </Link>

        </nav>


        {/* =========================================================
            LEFT SECTION
        ========================================================= */}
        <div className="left-section">

          {/* השאירו פרטים */}
          <Link
            to="/ContactSection2"
            className="cta-btn"
          >
            השאירו פרטים
          </Link>


          {/* טלפון */}
          <a
            href="tel:0506615262"
            className="contact"
          >

            {/* רק אייקון הטלפון שונה */}
            <span
              className="contact-icon"
              aria-label="טלפון"
            >
              ☎
            </span>

            <div className="contact-text">

              <span className="contact-title">
                לייעוץ ראשוני -
              </span>

              <span className="contact-number">
                050-6615262
              </span>

            </div>

          </a>


          {/* המבורגר */}
          <button
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="פתיחת תפריט"
          >
            {menuOpen ? "✕" : "☰"}
          </button>

        </div>

      </header>


      {/* =========================================================
          OVERLAY
      ========================================================= */}
      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={closeMobileMenu}
      />


      {/* =========================================================
          MOBILE MENU
      ========================================================= */}
      <div
        className={`mobile-menu ${menuOpen ? "open" : ""}`}
      >

        {/* סגירה */}
        <button
          className="close-btn"
          onClick={closeMobileMenu}
        >
          ✕
        </button>


        {/* בית */}
        <Link
          to="/"
          onClick={closeMobileMenu}
        >
          בית
        </Link>


        {/* =====================================================
            הובלת מבנים - MOBILE
        ===================================================== */}
        <div className="mobile-dropdown">

          <button
            className="mobile-drop-title"
            onClick={() =>
              setInfoOpenMobile(!infoOpenMobile)
            }
          >
            הובלת מבנים

            <span>
              {infoOpenMobile ? "▲" : "▼"}
            </span>

          </button>


          {infoOpenMobile && (
            <div className="mobile-submenu">

              <Link
                to="/Relocation_of_buildings/"
                onClick={closeMobileMenu}
              >
                העברת מבנים
              </Link>

              <Link
                to="/Sealingexteriorwalls/"
                onClick={closeMobileMenu}
              >
                הרמת מבנים
              </Link>

              <Link
                to="/BuildingRehabilitation/"
                onClick={closeMobileMenu}
              >
                הובלת קרוואנים
              </Link>

              <Link
                to="/Rooftarps/"
                onClick={closeMobileMenu}
              >
                הובלת מיגונית וממ”ד נייד
              </Link>

            </div>
          )}

        </div>


        {/* =====================================================
            הובלות עם מנוף הרמה - MOBILE
        ===================================================== */}
        <div className="mobile-dropdown">

          <button
            className="mobile-drop-title"
            onClick={() =>
              setMovingOpenMobile(!movingOpenMobile)
            }
          >
            הובלות עם מנוף הרמה

            <span>
              {movingOpenMobile ? "▲" : "▼"}
            </span>

          </button>


          {movingOpenMobile && (
            <div className="mobile-submenu">

              <Link
                to="/Transportation_of_building_materials"
                onClick={closeMobileMenu}
              >
                הובלת חומרי בניין
              </Link>

              <Link
                to="/Transporting_wood"
                onClick={closeMobileMenu}
              >
                הובלת עצים
              </Link>

              <Link
                to="/Transporting_heavy_equipment"
                onClick={closeMobileMenu}
              >
                הובלת ציוד כבד
              </Link>

              <Link
                to="/Container_Transportation"
                onClick={closeMobileMenu}
              >
                הובלת מכולות
              </Link>

              <Link
                to="/Transportation_and_lifting_of_glass_in_a_vacuum"
                onClick={closeMobileMenu}
              >
                הובלה והרמה של זכוכית בוואקום
              </Link>

              <Link
                to="/Transportation_of_industrial_and_heavy_generators"
                onClick={closeMobileMenu}
              >
                הובלת גנרטורים תעשייתיים וכבדים
              </Link>

            </div>
          )}

        </div>


        {/* =====================================================
            השכרת מנופים - MOBILE
        ===================================================== */}
        <div className="mobile-dropdown">

          <button
            className="mobile-drop-title"
            onClick={() =>
              setCranesOpenMobile(!cranesOpenMobile)
            }
          >
            השכרת מנופים

            <span>
              {cranesOpenMobile ? "▲" : "▼"}
            </span>

          </button>


          {cranesOpenMobile && (
            <div className="mobile-submenu">

              <Link
                to="/Basket_crane_rental/"
                onClick={closeMobileMenu}
              >
                השכרת מנוף סל
              </Link>

              <Link
                to="/Crane_Rental1/"
                onClick={closeMobileMenu}
              >
                השכרת מנוף זרוע
              </Link>

              <Link
                to="/Hourly_Lifting_Basket_Rental/"
                onClick={closeMobileMenu}
              >
                השכרת סל הרמה לפי שעה
              </Link>

              <Link
                to="/Renting_a_basket_crane_for_lifting_a_person/"
                onClick={closeMobileMenu}
              >
                השכרת מנוף סל להרמת אדם
              </Link>

            </div>
          )}

        </div>


        {/* =====================================================
            קישורים רגילים
        ===================================================== */}

        <Link
          to="/SealingContractors"
          onClick={closeMobileMenu}
        >
          השירותים שלנו
        </Link>

        <Link
          to="/WorksGallery"
          onClick={closeMobileMenu}
        >
          גלריית עבודות
        </Link>

        {/* אודות */}
        <Link
          to="/About"
          onClick={closeMobileMenu}
        >
          אודות
        </Link>

        <Link
          to="/ContactSection2"
          onClick={closeMobileMenu}
        >
          צור קשר
        </Link>

      </div>
    </>
  );
}